import { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/config";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function MilestoneForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [category, setCategory] = useState("physical");
  const [milestone, setMilestone] = useState("");
  const [notes, setNotes] = useState("");
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPhotoFile(file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!milestone) return;

    setUploading(true);
    try {
      let photoURL = null;
      if (photoFile) {
        const storageRef = ref(storage, `milestones/${Date.now()}_${photoFile.name}`);
        await uploadBytes(storageRef, photoFile);
        photoURL = await getDownloadURL(storageRef);
      }

      onAdd({
        date: new Date(date).toISOString(),
        category,
        milestone,
        notes: notes || "",
        type: "milestone",
        photoURL,
      });

      setDate(toDatetimeLocal());
      setMilestone("");
      setNotes("");
      setPhotoFile(null);
      setPhotoPreview(null);
    } finally {
      setUploading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Category</label>
          <select
            className="form-select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="physical">🏃 Physical</option>
            <option value="cognitive">🧠 Cognitive</option>
            <option value="social">👥 Social</option>
            <option value="language">🗣️ Language</option>
            <option value="other">✨ Other</option>
          </select>
        </div>
        <div className="col-md-4">
          <label className="form-label">Milestone</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. First steps, first word"
            value={milestone}
            onChange={(e) => setMilestone(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Optional details"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button type="submit" className="btn btn-success w-100" disabled={uploading}>
            {uploading ? (
              <><span className="spinner-border spinner-border-sm me-1" />Saving...</>
            ) : (
              "Add Milestone"
            )}
          </button>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-md-6">
          <label className="form-label">
            Photo <span style={{ fontSize: "0.8rem", color: "var(--text-light)" }}>(optional)</span>
          </label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handlePhotoChange}
          />
        </div>
        {photoPreview && (
          <div className="col-md-2 d-flex align-items-end">
            <img
              src={photoPreview}
              alt="Preview"
              style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px", border: "2px solid var(--border-light)" }}
            />
          </div>
        )}
      </div>
    </form>
  );
}
